import styled, {css} from 'styled-components';
import {Row} from 'react-bootstrap';
import SelectStyled from './SelectStyled';
import filterImg from '../../../assets/images/filter/filter.svg';

export const FiltersStyled = styled.div`
  background-color: #FFFFFF;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.05);
  margin-bottom: 20px;

  .clearfix {
    clear: both;
  }
`;

export const FilterSelectStyled = styled(SelectStyled)`
  box-sizing: border-box;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);

  &.fs-project-type-select {
    width: 100%;
  }
  &.fs-file-type-select {
    width: 50%;
  }

  .Select.is-searchable.Select--single .Select-control,
  .Select.is-searchable.Select--single .Select-control {
    border: 1px solid #E9E9E9;
    box-shadow: none;
    background: #fff;
    .Select-placeholder,
    .Select-value {
      color: #aaa !important;
      font-size: 10px !important;
      .Select-value-label {
        font-size: 10px !important;
      }
    }
  }
  .Select--multi .Select-control {
    border: 1px solid #E9E9E9;
    box-shadow: none;
    .Select-multi-value-wrapper {
      height: auto;
    }
    .Select-value {
      padding: 0 !important;
    }
    .Select-input {
      height: 24px;
      input {
        font-size: 10px;
        padding: 0;
      }
    }
  }

  &.filter-select-with-button {
    box-shadow: none;
    display: flex;
    justify-content: space-between;
    > .Select {
      flex-grow: 1;
    }
    > .filter-select-button {
      width: 20px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      i:hover {
        cursor: pointer;
      }
    }
    &.unsaved-right {
      position: relative;
      &:before {
        content: 'Unsaved changes';
        position: absolute;
        top: -12px;
        right: 45px;
        font-size: 9px;
        font-weight: bold;
        opacity: .8;
        color: #282828;
      }
    }
  }
`;

export const FilterHeaderStyled = styled.div`
  background: #575757;
  color: #FFFFFF;
  height: 44px;
  padding: 0 20px;
  cursor: pointer;
  .title {
    font-size: 13px;
    font-weight: bold;
    padding: 13px 15px;
    + .btn {
      margin-top: 8px;
      margin-left: 15px;
      padding: 6px 12px;
      font-size: 13px;
      line-height: 14px;
      outline: none !important;
      opacity: 0;
      &.is-visible {
        opacity: 1;
        transition: opacity 0.35s ease-in-out 0s;
      }
    }
  }
  i {
    font-size: 13px;
    font-weight: bold;
    padding: 13px 0;
    transition: transform 0.2s ease 0s;
    will-change: transform;
  }
  &[aria-expanded="false"] i {
    transform: rotate(-90deg);
  }
  .menu {
    display: flex;
    list-style: none;
    margin: 0;
    padding: 0;

    li {
      margin: 0 10px;
      padding: 10px 0;
      &:hover:not(.report-option) .btn-link span {
        max-width: 1000px;
        transition: all 1.5s ease-in-out;
      }
      &:not(.report-option) span {
        max-width: 0;
        overflow: hidden;
        transition: all 0.1s ease-in-out;
      }
      &.report-option {
        background-color: #464646;
        padding-right: 15px;
        padding-left: 15px;
      }
    }

    .btn-link {
      border: none;
      color: #ffffff;
      display: flex;
      height: 22px;
      line-height: 23px;
      white-space: nowrap;
      &:hover, &:focus {
        text-decoration: none;
        outline: none;
      }
      span {
        color: #FFFFFF;
        font-size: 10px;
        opacity: 0.5;
      }
    }
  }
`;

export const IconStyled = styled.i`
  background-repeat: no-repeat;
  background-position: center;
  display: block;
  margin: 0 3px;
  height: 21px;
  width: 21px;

  ${props => props.filt && css`
    background-image: url(${filterImg});
  `}
`;

export const FilterBodyStyled = styled(Row)`
  .block {
    padding: 15px 15px 0 15px;
    &.block-top {
      padding-bottom: 0;
    }
  }
  .title {
    align-items: center;
    color: #282828;
    display: flex;
    font-size: 10px;
  }
  .filters-block {
    margin-left: 30px;
    [class*="col-"] {
      padding: 0 3px;
    }
  }
`;

export const FilterBottomStyled = styled.div`
  padding: 0 40px;
  > div {
    border-top: 1px solid #f0f0f0;
    padding: 7px 0;
  }
  .btn {
    font-size: 13px;
    line-height: 14px;
    outline: none !important;
    & + .btn {
      margin-left: 5px;
    }
  }
`;
